<template>
<div class="chapter">
<div class="inner_page">
<div id="contents">
<div class="generated-style">
<p class="x2fm-ttl" xml:lang="en-us">Contents</p>
<div id="dedication">
<p class="x2toc"><em class="italic"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></em></p>
</div>
<div id="introduction">
<p class="x2toc-chap-num"><em class="italic"><a href="#/Introduction">Introduction</a></em></p>
</div>
<p class="x2toc" xml:lang="en-us">Four Broken Promises: Why the Tea Party Arose</p>
<div id="chapter-1">
<p class="x2toc-chap-num" xml:lang="en-us"><a href="#/Chapter_1">C<span class="small-caps">HAPTER</span> 1</a></p>
</div>
<p class="x2toc" xml:lang="en-us">The English Roots of American Liberty</p>
<div id="chapter-2">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_2" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 2</span></p>
</div>
<p class="x2toc" xml:lang="en-us">American Constitutionalism and the Formation of the Secular Covenant</p>
<div id="chapter-3">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_3" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 3</span></p>
</div>
<p class="x2toc" xml:lang="en-us">Alexander Hamilton and the Broken Promise of Plain Meaning</p>
<div id="chapter-4">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_4" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 4</span></p>
</div>
<p class="x2toc" xml:lang="en-us">The Republican Party and the Broken Promise of Free Markets</p>
<div id="chapter-5">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_5" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 5</span></p>
</div>
<p class="x2toc" xml:lang="en-us">Woodrow Wilson and the Divine Right of the State</p>
<div id="chapter-6">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_6" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 6</span></p>
</div>
<p class="x2toc" xml:lang="en-us">Republicans Fail to Offer an Alternative</p>
<div id="chapter-7">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_7" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 7</span></p>
</div>
<p class="x2toc" xml:lang="en-us">Hoover, FDR, and the Broken Promise of the Fiscal Constitution</p>
<div id="chapter-8">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_8" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 8</span></p>
</div>
<p class="x2toc" xml:lang="en-us">FDR’s Assault on Free Markets and the Constitution</p>
<div id="chapter-9">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_9" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 9</span></p>
</div>
<p class="x2toc" xml:lang="en-us">LBJ, Richard Nixon, and the Final Destruction of the Three Promises</p>
<div id="chapter-10">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_10" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 10</span></p>
</div>
<p class="x2toc" xml:lang="en-us">The Broken Promise of Deliberative Accountability and the Rise of the Tea Party Movement</p>
<div id="chapter-11">
<p class="x2toc-chap-num" xml:lang="en-us"><span href="#/Chapter_11" title="Link target outside of Sample">C<span class="small-caps">HAPTER</span> 11</span></p>
</div>
<p class="x2toc" xml:lang="en-us">Restoring the Secular Covenant: A Tea Party America Based on the Constitution</p>
<div id="acknowledgments">
<p class="x2toc-after-txb1"><em class="italic"><span href="#/Acknowledgments" title="Link target outside of Sample">Acknowledgments</span></em></p>
</div>
<div id="endnotes">
<p class="x2toc"><em class="italic"><span href="#/Endnotes" title="Link target outside of Sample">Endnotes</span></em></p>
</div>
<div id="index">
<p class="x2toc"><em class="italic"><span href="#/Index" title="Link target outside of Sample">Index</span></em></p>
</div>
<div id="about-the-author">
<p class="x2toc"><em class="italic"><span href="#/About_the_Author#about-the-author" title="Link target outside of Sample">About the Author</span></em></p>
</div>
<div id="credits">
<p class="x2toc-after-txb1"><em class="italic"><span href="#/Credits" title="Link target outside of Sample">Credits</span></em></p>
</div>
<div id="copyright">
<p class="x2toc"><em class="italic"><span href="#/Copyright" title="Link target outside of Sample">Copyright</span></em></p>
</div>
<div id="about-the-publisher">
<p class="x2toc"><em class="italic"><span href="#/About_the_Publisher" title="Link target outside of Sample">About the Publisher</span></em></p>
</div>
<div id="footnotes">
<p class="x2toc-after-txb1"><em class="italic"><span href="#/Footnotes" title="Link target outside of Sample">Footnotes</span></em></p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?c9c5eb80